//export const URL_BASE = 'https://campusvirtualapi-beta.azurewebsites.net/';
export const URL_BASE = "https://campusvirtualapi.azurewebsites.net/";
//Token
export const DEFTKN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJDYW1wdXNWaXJ0dWFsQXBpIiwiaWF0IjoiMTU1NTgwMjcwOCIsImV4cCI6IjE4NzE0MjE5MDUiLCJlbWFpbCI6IldlYlBheVBsdXNAc2lzLmVkdS5teCIsImlkX2luc3RpdHVjaW9uIjoiMSIsImlkX3BlcnNvbmEiOiIyIiwiY2FuYWxfY29tdW5pY2FjaW9uIjoiIiwibW9vZGxlX3VzZXJfaWQiOiIiLCJtb29kbGVfdG9rZW4iOiIiLCJyb2wiOiIiLCJhbHVtbm8iOiIiLCJnbXQiOiItNiJ9.fTo8irf2IeUcDR8tOjU81TVVAXgrg_yf9yYZjIM9jbk";

export const DEFTKNCCEPO =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJDYW1wdXNWaXJ0dWFsQXBpIiwiaWF0IjoiMTc0MzI4ODAyMiIsImV4cCI6IjE3NDU5NjY0MjIiLCJlbWFpbCI6ImNvYnJhbnphQGNhbXB1c3ZpcnR1YWwubXgiLCJpZF9pbnN0aXR1Y2lvbiI6IjMiLCJpZF9wZXJzb25hIjoiMiIsImNhbmFsX2NvbXVuaWNhY2lvbiI6IiIsIm1vb2RsZV91c2VyX2lkIjoiIiwibW9vZGxlX3Rva2VuIjoiIiwicm9sIjoiIiwiYWx1bW5vIjoiIiwiZ210IjoiLTYifQ.IT86hBt0F2LoFRYEQ4dqQn0Vk97Be4C5wp2CoGedYcU";

//CardPay Url
export const URL_CARDPAY = "https://oppwa.com/";

export const URL_HOSTING = "https://pagos-dev.campusvirtual.mx/";
//export const URL_HOSTING = "https://pagos.campusvirtual.mx/";
//export const URL_HOSTING = "https://ccepo_pagos.campusvirtual.mx/";

// export const IDINSTITUCION = 1;
export const ID_INSTITUCION = 3; // Ccepo

export default URL_BASE;
